import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { colors } = theme.other;
  return {
    contentContainer: {
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      overflowY: 'auto',
      paddingTop: '0',
    },
  }
});

export default useStyles;
